/*
 *
 * OperationDetailModal
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 06-Dec-2024
 */

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import OperationDetailModal from './OperationDetailModal'
import { doPopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  data: state?.popup?.popupData || {}
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(OperationDetailModal)
